<template lang="pug">
  title-tab(:msg="'รายการโพย'")
    template(v-slot:extensionBottom)
      v-tabs(
        v-model='currentItem'
        background-color='var(--bg-main-color)'
      )
        v-tab(
          v-for='(header,iH) in headers'
          :key='iH'
          @click="GA('SelectTab',header)"
        )
          h4 {{ $t(header) }}
    component(
      ref='allListRef'
      :is="currentView"
      @addDialog='addDialog'
      @remove='deleteBet'
    )
    dialog-view(
      v-if="showGameDetail"
      ref='dialogViewRef'
      :form="form"
      @close="closeGameDetail"
      @remove='deleteBet'
    )
</template> 
<script> 

import { st as apiSt } from '@/apis'  
import lotto from "./childs/AllList";  
import gameList from "./childs/GameList";  
import result from "./childs/Result";  
import dialogView from "./childs/dialogView" 

export default {
  components: {
    lotto,
    gameList,  
    result, 
    dialogView
  },
  data () {
    return { 
      currentItem: 0,
      headers: [
        "tab.list-lotto",
        "tab.list-game",  
        "tab.bet-summary"
      ],
      showGameDetail: false,
      form: {}
    };
  },
  computed: {
    currentView () {
      switch(this.currentItem) {
        case 0:
          return 'lotto'
        case 1:
          return 'gameList'
        case 2:
          return 'result'
      } 
      return 'releaselist'
    }
  },
  methods: { 
    GA (actions,item) {
      this.$ga.event('Button', actions, 'StakeListPage',item )
    },
    async addDialog (item) {
      const [err,data] = await apiSt.getListById(item.list_uuid)
      
      if(err) {
        this.$alert('',err,'warning') 
        return
      }

      // let form =  {
      //     name: data.room.name,
      //     data: data.lists,
      //     stake_status: item.stake_status
      //   }

      this.form =  {
        data: data,
        item: item
      }

      this.showGameDetail = true
        
      // this.$nextTick(()=>{
      //   this.showGameDetail = true
      //   // this.$refs.dialogViewRef.open(form)   

      // }) 
    },
    async deleteBet (uuid) {
      const confirm = await this.$confirm('',this.$t('confirm.return-lotto-list'),'warning')

      if(!confirm) {
        return
      }

      const [err,] = await apiSt.cancel(uuid)
      
      if(err) {
        this.$alert('',err,'warning') 
        return
      }
      
      if(this.currentItem!==2 && this.$refs.allListRef){
        this.$refs.allListRef.load({reset: 1})
      }

      this.showGameDetail = false
    },
    closeGameDetail () {
      this.showGameDetail = false
    } 
  }
};
</script> 